import styled from 'styled-components';
import { Box, Heading, Link, Text } from '@99designs/emu';
import { IconTick2 } from '@99designs/icons';
import { linkTo } from '@99designs/routing';
import type { ZendeskLanguage } from '@99designs/routing';

const Container = styled(Box)`
    line-height: 1;
`;

const StyledIconTick2 = styled(IconTick2)`
    margin-top: 2px;
`;

interface Props {
    lang: ZendeskLanguage;
}

export function MoneyBackGuarantee({ lang }: Props) {
    return (
        <Container display="flex" alignItems="flex-start">
            <StyledIconTick2 width="30px" height="30px" />
            <Box paddingLeft="0.5bu">
                <Heading appearanceLevel={6} accessibilityLevel={6} as="div">
                    {__('100% money back guarantee')}
                </Heading>
                <Text size="size1" as="div">
                    {__('A design you love or your money back')}
                </Text>
                <Link size="size1" href={`${linkTo.supportUrl('204108729', 'articles', lang)}`}>
                    {__('T&Cs apply')}
                </Link>
            </Box>
        </Container>
    );
}
